import { PROFILE_ICON_COLORS } from '@/feature/profiles/constants';
import { useEffect, useState } from 'react';

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
};

// Create color map from PROFILE_ICON_COLORS
const colorMap = PROFILE_ICON_COLORS.reduce(
  (map, { name, color }) => {
    map[name] = color;
    return map;
  },
  {} as Record<string, string>,
);

export const getProfileColor = (avatarType: string): string => {
  return colorMap[avatarType] ?? '#6B7280';
};
